"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateListItem = exports.storeBy = exports.store = exports.N = exports.isNothing = exports.editListIndex = exports.editListItem = exports.editList = void 0;
var R = __importStar(require("ramda"));
/** Copies a list and sets or updates the properties of all items matching the predicate.
 *
 * NOTE: This function is not auto-curried. */
var editList = function (newProperties, pred, list) {
    return R.map(function (item) { return pred(item) ? R.mergeRight(item, newProperties) : item; }, list);
};
exports.editList = editList;
/** Copies a list and sets or updates the properties of the first item matching the predicate.
 *
 * NOTE: This function is not auto-curried. */
var editListItem = function (newProperties, pred, list) {
    var index = R.findIndex(pred, list);
    return index > -1 ? R.update(index, R.mergeRight(list[index], newProperties), list) : R.identity(list);
};
exports.editListItem = editListItem;
/** Copies a list and replaces the first item matching the predicate.
 *
 * NOTE: This function is not auto-curried. */
var updateListItem = function (newItem, pred, list) {
    var index = R.findIndex(pred, list);
    return index > -1 ? R.update(index, newItem, list) : R.identity(list);
};
exports.updateListItem = updateListItem;
/** Copies a list and sets or updates the properties of the item at the specified index.
 *
 * NOTE: This function is not auto-curried. */
var editListIndex = function (newProperties, index, list) {
    return R.update(index, R.mergeRight(list[index], newProperties), list);
};
exports.editListIndex = editListIndex;
/** Does nothing. Useful as a placeholder. */
var N = function () { };
exports.N = N;
/** Returns `true` if the given value is `null`, `undefined`, or empty (via `R.isEmpty`); `false` otherwise.  */
var isNothing = R.either(R.isNil, R.isEmpty);
exports.isNothing = isNothing;
/** Converts an array into a key/value object with the specified element property as object's keys. */
var store = function (key, list) {
    return list.reduce(function (map, item) {
        var newKey = typeof key === "function" ? key(item) : R.prop(key.toString(), item);
        return R.assoc(newKey.toString(), item, map);
    }, {});
};
exports.store = store;
var storeBy = function (key, valFunc, list) {
    return list.reduce(function (map, item) {
        var newKey = typeof key === "function" ? key(item) : R.prop(key.toString(), item);
        return R.assoc(newKey.toString(), valFunc(item), map);
    }, {});
};
exports.storeBy = storeBy;
__exportStar(require("ramda"), exports);
